const PageHeader = ({ title }) => {
  return (
    <header id="header" className="ex-header">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h1 className="white">
              {title}
            </h1>
          </div>
        </div>
      </div>
    </header>
  );
};

export default PageHeader;
